import i18n from './i18n'

export const isCurrency = {
  name: 'is-currency',
  skipAbsent: true,
  test (value: string | undefined, ctx: any) {
    const regex = /^[-+]?(\d+(\.\d{1,2})?)([-+]\d+(\.\d{1,2})?)*$/
    if (value && !regex.test(value)) {
      return ctx.createError({ message: i18n.t('common:validation.invalidAmount') })
    }
    return true
  },
}
